<script lang="ts">
    import { createEventDispatcher, getContext } from "svelte";
    import type { Supabase } from "./structure";

    let name: string;
    let email: string;
    let password: string;

    const emiter = createEventDispatcher();

    const supabase: Supabase = getContext("supabase");

    const register = async () => {
        const { data, error } = await $supabase
            .from("users")
            .select("*")
            .ilike("email", email);
        if (data.length !== 0) {
            return;
        }
        const { data: registerData, error: registerError } = await $supabase
            .from("users")
            .insert({
                email: email.toLowerCase(),
                password,
                data: { balance: 5 },
            });
        if (registerError) {
            console.log(registerError.message);
        }
        console.log(registerData, registerError);
        emiter("confirm");
    };
</script>

<div class="space-y-4 text-center">
    <h1
        class="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl/none"
    >
        Welcome to our Casino!
    </h1>
    <p
        class="max-w-[600px] text-gray-500 md:text-xl/relaxed lg:text-base/relaxed xl:text-xl/relaxed dark:text-gray-400"
    >
        Register now and get $5 for free!
    </p>
</div>
<div class="max-w-sm space-y-4 mt-4">
    <div class="flex flex-col space-y-2">
        <input
            class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
            placeholder="Enter your name"
            type="text"
            bind:value={name}
        /><input
            class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
            placeholder="Enter your email"
            type="email"
            bind:value={email}
        /><input
            class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
            placeholder="Enter your password"
            type="password"
            bind:value={password}
        /><button
            class="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 w-full"
            on:click={register}>Register</button
        >
    </div>

    <div class="text-sm text-center">
        <span class=""
            >Already have an account? <button
                on:click
                class="text-blue-600 font-semibold">Login</button
            ></span
        >
    </div>
    <div class="flex items-center justify-center space-x-2 text-sm">
        <span class="font-semibold">Time left to claim your bonus:</span>
        <div class="flex items-center space-x-1">
            <span class="font-mono">23</span><span>:</span><span
                class="font-mono">59</span
            ><span>:</span><span class="font-mono">59</span>
        </div>
    </div>
</div>
